import React from "react"
import { Center, Text } from "@chakra-ui/react"

const PageSummary = ({ children }: React.PropsWithChildren) => (
  <Center as="section" justifyContent="center" py={2} w="full" pl={[2.5, 0]} pr={[2.5, 0]}>
    <Text
      size="sm"
      color="#7B7670"
      textAlign="center"
      w={["unset", "868px"]}
      sx={{
        p: { color: "#7B7670", size: "14px" },
      }}
    >
      {children}
    </Text>
  </Center>
)

export default PageSummary
